import { render, staticRenderFns } from "./PageLevel.vue?vue&type=template&id=1e943ed6&scoped=true"
import script from "./PageLevel.vue?vue&type=script&lang=js"
export * from "./PageLevel.vue?vue&type=script&lang=js"
import style0 from "./PageLevel.vue?vue&type=style&index=0&id=1e943ed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e943ed6",
  null
  
)

export default component.exports